<template>
  <wo-region v-if="showList">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.companies.title'"></wo-title>
      <wo-grid>
        <wo-column width-md="6">
          <po-input-field v-model="searchText" v-focus="true" name="searchText" label-key="general.searchText" :debounce="true" />
        </wo-column>
      </wo-grid>
    </wo-layout>
    <wo-spacer />
    <wo-layout v-if="hasCompanies">
      <wo-card :title="$t('admin.companies.matching')">
        <po-route-link :value="createRoute" slot="actions"></po-route-link>
        <po-table>
          <po-table-header :columns="tableColumns" slot="header" />
          <template slot="body">
            <tr v-for="company in companies.items" :key="company.id">
              <td><po-route-link :value="getRoute(company)" :label="company.name" /></td>
              <td><span v-if="company.account_number">{{ company.account_number }}</span></td>
              <td>{{ company.created_on | date }}</td>
            </tr>
          </template>
        </po-table>
        <po-paging v-model="currentPage" :data="companies" />
      </wo-card>
    </wo-layout>
    <po-empty-state v-else />
  </wo-region>
  <router-view v-else />
</template>

<script>

import _ from 'lodash'
import { mapState } from 'vuex'
import filtered from '@/mixins/filtered'

import { companyRepository } from '@/repository/company'

import { ADMIN_COMPANY, ADMIN_COMPANIES, ADMIN_COMPANY_CREATE } from '@/routes/admin'

export default {
  mixins: [filtered],
  data () {
    return {
      searchText: undefined
    }
  },
  computed: mapState({
    companies: state => state.company.companyList,
    hasCompanies () {
      return this.companies && !_.isEmpty(this.companies.items)
    },
    showList () {
      return this.$route.name === ADMIN_COMPANIES
    },
    createRoute () {
      return ADMIN_COMPANY_CREATE
    },
    tableColumns () {
      return [
        { labelKey: 'company.name', prop: 'name' },
        { labelKey: 'company.customer', prop: 'account_number' },
        { labelKey: 'general.createdOn', prop: 'created_on' }
      ]
    },
    filter () {
      return {
        search_text: this.searchText
      }
    }
  }),
  methods: {
    applyFilter (filter, pristine) {
      return this.$store.dispatch(companyRepository.findAll, { filter: filter, replace: !pristine })
    },
    getRoute (company) {
      return {
        name: ADMIN_COMPANY,
        params: { companyId: company.id }
      }
    }
  }
}
</script>
